export default __webpack_public_path__ + "static/yum-e3693c4fc2cbcc677a0fbe9f5c55e689.svg";